<script>

</script>

<div class="form-group">
    <slot></slot>
</div>

<style global lang="scss">
.form-group {
    @apply font-semibold flex flex-wrap md:flex-nowrap;
}
</style>